/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'

export default {
    // Set mails flag unread to true
    createTask({ commit }, payload) {
      // commit("SET_ACTIVE_PROJECT_TITLE", payload.title)
      var taskInfo = {"title": payload.title, "project_id": payload.projectId}
      return new Promise((resolve, reject) => {
        axios.post("/api/project/task/create", taskInfo).then((response) =>{
          if(response.data.result == 'success'){

            commit("CREATE_TASK", response.data.data)
            resolve(response.data.data)
          }
          reject(resolve)
        }).catch((error) => { reject(error) })
      })
    },
    updateTaskState({ commit }, payload) {
      var taskInfo = {"id": payload.id, "state": payload.state}
      return new Promise((resolve, reject) => {
        axios.post("/api/project/task/state/update", taskInfo)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_TASK_STATE", payload)
              if(payload.state == 3){
                commit("UPDATE_DONE_TASK", response.data.data)
              }
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
      })
    },
    updateTask({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/project/task/update", payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_TASK", response.data.data)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
      })
    },
    deleteTask({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/project/task/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_TASK", payload)
              commit("DELETE_DONE_TASK", payload)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
      })
    },
    getTask({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/project/task/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_TASK_LIST", response.data.data_list)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    getDoneTask({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/project/task/done/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_DONE_TASK_LIST", response.data.data_list)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    getMyblog({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.get("/api/project/task/blog/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_TASK_BLOGS", response.data.data_list)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    getProjectMember({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.get("/api/project/member/"+payload).then((response) => {
          if(response.data.result == 'success'){
            commit("SET_PROJECT_MEMBER", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error)=>{reject(error)})
      })
    },
    getUserTask({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.get("/api/project/task/user/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_USER_TASKS", response.data.data_list)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    }
}
